import { TFunction } from 'i18next';
import { Dispatch } from 'redux';
import { EventContext, EventErrorContext } from '@okta/okta-signin-widget';
import logger from '../../../utils/logger';
import { resetErrorCounter, setErrorCounterUsername } from '../LoginPage.actions';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function onAfterError(context: EventContext, error: EventErrorContext, errorCounter: number, username: string, dispatch: Dispatch<any>, t: TFunction<'LoginPage'>): boolean {
  const usernameControl = document.getElementById('okta-signin-username') as HTMLInputElement;
  const currentUsername = usernameControl.value;

  const msg = `Controller:${context.controller} Username: ${currentUsername} Error Name:${error.name} Error Message:${error.message} Error Status Code:${error.statusCode} Error Code:${error.xhr.responseJSON.errorCode}`;
  logger.error(msg);

  const passControl = document.getElementById('okta-signin-password') as HTMLInputElement;
  passControl.value = '';

  let localErrorCounter = errorCounter;
  if (currentUsername !== username) {
    dispatch(setErrorCounterUsername(currentUsername));
    localErrorCounter = 0;
    dispatch(resetErrorCounter());
  }
  const elems = document.getElementsByTagName('p');
  for (let i = 0; i < elems.length; i++) {
    if (elems[i].textContent === t('loginError')) {
      if (localErrorCounter >= 6) {
        elems[i].textContent = t('loginErrorCounter');
        return false;
      }
      return true;
    }
  }
  return false;
}
